import { defineComponent, createElementBlock, openBlock, normalizeClass, unref, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogHeader",
  props: {
    class: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createElementBlock("div", {
      "data-slot": "alert-dialog-header",
      class: normalizeClass(unref(cn)("flex flex-col gap-2 text-center sm:text-left", props.class))
    }, [
      renderSlot(_ctx.$slots, "default")
    ], 2));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogHeader.js.map
